import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const requerimento_api = {
    getList: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Requerimento/getlist/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListRequerimentoAgendamento: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Requerimento/getlistrequerimentoagendamento/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListRequerimentoAgendamentosDia: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Requerimento/getlistrequerimentoagendamentosdia/`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Requerimento/getitem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getRequerimentoCadastro: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Requerimento/getrequerimentocadastro/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (requerimento) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Requerimento`, requerimento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postInterno: (requerimento) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Requerimento/interno`, requerimento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (requerimento) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Requerimento`, requerimento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postDocumento: (documento) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Requerimento/postdocumento`, documento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putDocumento: (documento) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Requerimento/putdocumento`, documento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    insertAcaoRequerimento: (acao) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Requerimento/insertacao`, acao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    MudarSituacaoEspecie: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Requerimento/MudarSituacaoEspecie/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default requerimento_api;
